export const TAB_OPTIONS = [
  { label: '自由改款', value: 'free' },
  { label: '款式上身', value: 'fit' },
  { label: '更换背景', value: 'background' },
  { label: '更换模特', value: 'model' },
]

export const MODEL_ICON_URL = 'https://cdn.zhiyitech.cn/material/ed3b60ec6a98c7aa25f99c3c8d27d1cc'

export const MODEL_OPTIONS = [
  {
    label: 'FD+3.0 Max',
    value: 'nano_banana_pro_official',
    description: '画面还原度高，2K/4K自由切换，输出稳定',
    icon: MODEL_ICON_URL,
  },
  {
    label: 'FD+2.5 Max',
    value: 'gpt-image-2',
    description: '文本理解能力强，生图颜色一致性好',
    icon: MODEL_ICON_URL,
  },
  {
    label: 'FD+3.0 Pro',
    value: 'nano_banana_pro',
    description: '生成效果好，2K/4K超清分辨率随心切换',
    icon: MODEL_ICON_URL,
  },
  {
    label: 'FD+3.0',
    value: 'doubao-seedream-5.0-lite',
    description: '大尺度专属定制，色彩饱和度高',
    tag: '支持大尺度',
    icon: MODEL_ICON_URL,
  },
  {
    label: 'FD+2.0 Pro',
    value: 'nano_banana_2',
    description: '文字生成能力强，画面还原度好',
    icon: MODEL_ICON_URL,
  },
]

export const RATIO_OPTIONS = [
  { label: 'auto', value: 'auto' },
  { label: '1:1', value: '1:1', icon: { width: '24px', height: '24px' } },
  { label: '3:4', value: '3:4', icon: { width: '18px', height: '24px' } },
  { label: '4:5', value: '4:5', icon: { width: '19.2px', height: '24px' } },
  { label: '2:3', value: '2:3', icon: { width: '16px', height: '24px' } },
  { label: '9:16', value: '9:16', icon: { width: '13.5px', height: '24px' } },
  { label: '4:3', value: '4:3', icon: { width: '24px', height: '18px' } },
  { label: '5:4', value: '5:4', icon: { width: '24px', height: '19.2px' } },
  { label: '3:2', value: '3:2', icon: { width: '24px', height: '16px' } },
  { label: '16:9', value: '16:9', icon: { width: '24px', height: '13.5px' } },
  { label: '21:9', value: '21:9', icon: { width: '24px', height: '10.29px' } },
  { label: '9:21', value: '9:21', icon: { width: '10.29px', height: '24px' } },
]

export const QUALITY_OPTIONS = [
  { label: '2K', value: '2k' },
  { label: '4K', value: '4k' },
]

export const DEFAULT_MODEL = 'nano_banana_pro'
export const DEFAULT_QUALITY = '2k'
export const DEFAULT_RATIO = '3:4'
export const FDAI_MESSAGE_SOURCE = 'fd_ai_meinian'

const FD_3_RATIO_OPTIONS = ['auto', '1:1', '3:4', '4:5', '2:3', '9:16', '4:3', '5:4', '3:2', '16:9', '21:9']
const DOUBAO_2K_RATIO_OPTIONS = ['auto', '1:1', '3:4', '4:3', '16:9', '9:16', '3:2', '2:3', '21:9']
const GPT_IMAGE_2_2K_RATIO_OPTIONS = ['auto', '1:1', '3:4', '4:3', '2:3', '3:2', '16:9', '9:16', '4:5', '5:4', '9:21', '21:9']

export const MODEL_RATIO_OPTIONS = {
  '2k': {
    nano_banana_pro_official: FD_3_RATIO_OPTIONS,
    nano_banana_pro: FD_3_RATIO_OPTIONS,
    nano_banana_2: FD_3_RATIO_OPTIONS,
    'doubao-seedream-5.0-lite': DOUBAO_2K_RATIO_OPTIONS,
    'gpt-image-2': GPT_IMAGE_2_2K_RATIO_OPTIONS,
  },
  '4k': {
    nano_banana_pro_official: FD_3_RATIO_OPTIONS,
    nano_banana_pro: FD_3_RATIO_OPTIONS,
    nano_banana_2: FD_3_RATIO_OPTIONS,
    'gpt-image-2': ['9:16'],
  },
}

export const getQualityOptions = model => {
  if (model === 'doubao-seedream-5.0-lite') {
    return QUALITY_OPTIONS.filter(item => item.value !== '4k')
  }
  return QUALITY_OPTIONS
}

export const getSupportedRatios = (model, quality) => {
  const normalizedQuality = String(quality || DEFAULT_QUALITY).toLowerCase()
  return MODEL_RATIO_OPTIONS[normalizedQuality]?.[model] || MODEL_RATIO_OPTIONS[DEFAULT_QUALITY][DEFAULT_MODEL]
}

export const getRatioOptions = (model, quality) => {
  const supportedRatios = getSupportedRatios(model, quality)
  return supportedRatios.map(ratio => RATIO_OPTIONS.find(item => item.value === ratio)).filter(Boolean)
}

export const normalizeGenerateParams = ({ model = DEFAULT_MODEL, quality = DEFAULT_QUALITY, ratio = DEFAULT_RATIO }) => {
  const qualityOptions = getQualityOptions(model)
  const nextQuality = qualityOptions.some(item => item.value === quality) ? quality : qualityOptions[0].value
  const supportedRatios = getSupportedRatios(model, nextQuality)
  const nextRatio = supportedRatios.includes(ratio) ? ratio : supportedRatios[0]

  return {
    model,
    quality: nextQuality,
    ratio: nextRatio,
  }
}

export const MAX_REF_IMGS = 4
export const IMG_LABELS = ['图一', '图二', '图三', '图四', '图五']

export const SUB_TAB_OPTIONS = [
  { label: '最近采集', value: 'recent' },
  { label: '最近使用', value: 'used' },
]

// 本地模板数据
export const TEMPLATE_DATA = {
  fit: '[{"type": "text", "value": "将"}, {"type": "input", "value": "图1"}, {"type": "text", "value": "中的款式穿到"}, {"type": "input", "value": "图2"}, {"type": "text", "value": "的模特身上，穿着方式为"}, {"type": "select", "value": "拉链（纽扣）打开", "options": ["拉链（纽扣）打开", "拉链（纽扣）闭合"]}]',
  background: '[{"type": "text", "value": "将"}, {"type": "input", "value": "图2"}, {"type": "text", "value": "的背景应用于"}, {"type": "input", "value": "图1"}, {"type": "text", "value": "的角色背景，保持"}, {"type": "input", "value": "图1"}, {"type": "text", "value": "的角色姿势不变，最终只有"}, {"type": "input", "value": "图1"}, {"type": "text", "value": "的角色出现在"}, {"type": "input", "value": "图2"}, {"type": "text", "value": "的场景中，场景要合理化。注意：删除"}, {"type": "input", "value": "图1"}, {"type": "text", "value": "的背景，删除"}, {"type": "input", "value": "图2"}, {"type": "text", "value": "的角色，"}]',
  model: '[{"type": "text", "value": "将"}, {"type": "input", "value": "图1"}, {"type": "text", "value": "中的模特更换为"}, {"type": "input", "value": "图2"}, {"type": "text", "value": "的模特，并确保款式、背景及穿着方式不变。"}]',
}
